import {
  Grid,
  InputAdornment,
  Input,
  FormControl,
  InputLabel,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import useStore from '../zustand/useStore';

const SearchBar = () => {
  const {
    setFilter,
    filters: { search },
  } = useStore((state) => ({
    setFilter: state.setFilter,
    filters: state.filters,
  }));

  return (
    <Grid container style={{ width: '100%', margin: '3rem auto 0' }}>
      <Grid item xs={8}>
        <FormControl variant="standard" fullWidth size="l">
          <InputLabel htmlFor="search">Search</InputLabel>
          <Input
            label="search"
            id="search"
            variant="standard"
            style={{ fontSize: '1.5rem' }}
            value={search}
            onChange={(e) => setFilter('search', e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <FontAwesomeIcon icon={faSearch} style={{ margin: '0 1rem' }} />
              </InputAdornment>
            }
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};
export default SearchBar;
